import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navigation from "../components/Navigation";

const TransactionHistoryScreen = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState("all");

  // Mock transaction data
  const transactions = [
    {
      id: 1,
      date: "2024-01-15",
      symbol: "AAPL",
      name: "Apple Inc.",
      type: "buy",
      shares: 5.0,
      price: 150.23,
      total: 751.15,
      fees: 4.95,
    },
    {
      id: 2,
      date: "2024-01-14",
      symbol: "TSLA",
      name: "Tesla Inc.",
      type: "sell",
      shares: 2.0,
      price: 245.67,
      total: 491.34,
      fees: 4.95,
    },
    {
      id: 3,
      date: "2024-01-12",
      symbol: "MSFT",
      name: "Microsoft Corp.",
      type: "buy",
      shares: 3.5,
      price: 378.45,
      total: 1324.58,
      fees: 4.95,
    },
    {
      id: 4,
      date: "2024-01-10",
      symbol: "GOOGL",
      name: "Alphabet Inc.",
      type: "buy",
      shares: 2.1,
      price: 142.89,
      total: 300.07,
      fees: 4.95,
    },
    {
      id: 5,
      date: "2024-01-08",
      symbol: "AAPL",
      name: "Apple Inc.",
      type: "sell",
      shares: 3.0,
      price: 148.9,
      total: 446.7,
      fees: 4.95,
    },
  ];

  const filteredTransactions =
    filter === "all"
      ? transactions
      : transactions.filter((t) => t.type === filter);

  const totalBuy = transactions
    .filter((t) => t.type === "buy")
    .reduce((sum, t) => sum + t.total, 0);

  const totalSell = transactions
    .filter((t) => t.type === "sell")
    .reduce((sum, t) => sum + t.total, 0);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div className="screen">
      <div className="screen-header">
        <h1 className="screen-title">Transaction History</h1>
        <p className="screen-subtitle">
          View all your buy and sell transactions
        </p>
      </div>

      {/* Summary Stats */}
      <div className="portfolio-summary">
        <div className="portfolio-card">
          <div className="portfolio-value">${totalBuy.toFixed(2)}</div>
          <div className="portfolio-label">Total Bought</div>
        </div>
        <div className="portfolio-card">
          <div className="portfolio-value">${totalSell.toFixed(2)}</div>
          <div className="portfolio-label">Total Sold</div>
        </div>
        <div className="portfolio-card">
          <div className="portfolio-value">{transactions.length}</div>
          <div className="portfolio-label">Total Transactions</div>
        </div>
      </div>

      {/* Filter Buttons */}
      <div className="card">
        <div className="flex gap-2" style={{ marginBottom: "20px" }}>
          <button
            onClick={() => setFilter("all")}
            className={`btn ${filter === "all" ? "" : "btn-outline"} btn-small`}
          >
            All ({transactions.length})
          </button>
          <button
            onClick={() => setFilter("buy")}
            className={`btn ${filter === "buy" ? "" : "btn-outline"} btn-small`}
          >
            Buys ({transactions.filter((t) => t.type === "buy").length})
          </button>
          <button
            onClick={() => setFilter("sell")}
            className={`btn ${
              filter === "sell" ? "" : "btn-outline"
            } btn-small`}
          >
            Sells ({transactions.filter((t) => t.type === "sell").length})
          </button>
        </div>

        {/* Transactions List */}
        <div className="grid-2">
          {filteredTransactions.map((transaction) => (
            <div key={transaction.id} className="stock-item">
              <div className="stock-header">
                <div>
                  <div className="stock-name">{transaction.name}</div>
                  <div className="stock-symbol">{transaction.symbol}</div>
                  <div style={{ fontSize: "0.9rem", color: "#94A3B8" }}>
                    {formatDate(transaction.date)}
                  </div>
                </div>
                <div className="text-right">
                  <div
                    className={`stock-change ${
                      transaction.type === "buy" ? "positive" : "negative"
                    }`}
                  >
                    {transaction.type.toUpperCase()}
                  </div>
                  <div className="stock-price">
                    ${transaction.total.toFixed(2)}
                  </div>
                </div>
              </div>
              <div
                style={{
                  color: "#94A3B8",
                  fontSize: "0.9rem",
                  marginTop: "8px",
                }}
              >
                <div>Shares: {transaction.shares}</div>
                <div>Price: ${transaction.price.toFixed(2)}</div>
                <div>Fees: ${transaction.fees.toFixed(2)}</div>
              </div>
            </div>
          ))}
        </div>

        {filteredTransactions.length === 0 && (
          <div
            className="text-center"
            style={{ color: "#94A3B8", padding: "40px" }}
          >
            No {filter === "all" ? "" : filter} transactions found
          </div>
        )}
      </div>

      {/* Quick Actions */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Quick Actions</h3>
        </div>
        <div className="grid-2">
          <button
            onClick={() => navigate("/add-transaction")}
            className="btn btn-large"
          >
            ➕ Add Transaction
          </button>
          <button
            onClick={() => navigate("/add-investment")}
            className="btn btn-secondary btn-large"
          >
            💰 Add Investment
          </button>
          <button
            onClick={() => navigate("/invest")}
            className="btn btn-outline btn-large"
          >
            📈 View Portfolio
          </button>
          <button
            onClick={() => navigate("/market")}
            className="btn btn-outline btn-large"
          >
            📊 Browse Market
          </button>
        </div>
      </div>

      <Navigation />
    </div>
  );
};

export default TransactionHistoryScreen;
